// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9eN9w","link":"styles_link__Awikw","home":"styles_home__a7_8D","homeIcon":"styles_homeIcon__kDoIz"};